import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\ActionScreenRebootByIdController::__invoke
* @see app/Http/Controllers/Screen/ActionScreenRebootByIdController.php
* @route '/api/screen-settings/{screen}/reboot'
*/
const ActionScreenRebootByIdController = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ActionScreenRebootByIdController.url(args, options),
    method: 'get',
})

ActionScreenRebootByIdController.definition = {
    methods: ["get","head"],
    url: '/api/screen-settings/{screen}/reboot',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\ActionScreenRebootByIdController::__invoke
* @see app/Http/Controllers/Screen/ActionScreenRebootByIdController.php
* @route '/api/screen-settings/{screen}/reboot'
*/
ActionScreenRebootByIdController.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return ActionScreenRebootByIdController.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\ActionScreenRebootByIdController::__invoke
* @see app/Http/Controllers/Screen/ActionScreenRebootByIdController.php
* @route '/api/screen-settings/{screen}/reboot'
*/
ActionScreenRebootByIdController.get = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ActionScreenRebootByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\ActionScreenRebootByIdController::__invoke
* @see app/Http/Controllers/Screen/ActionScreenRebootByIdController.php
* @route '/api/screen-settings/{screen}/reboot'
*/
ActionScreenRebootByIdController.head = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ActionScreenRebootByIdController.url(args, options),
    method: 'head',
})

export default ActionScreenRebootByIdController